import { render, staticRenderFns } from "./MemberCrmNav.vue?vue&type=template&id=23767697&"
import script from "./MemberCrmNav.vue?vue&type=script&lang=ts&"
export * from "./MemberCrmNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports